document.documentElement.classList.remove('no-js');

const $ = (selector, context = document) => context.querySelector(selector);
const $$ = (selector, context = document) => [...context.querySelectorAll(selector)];

document.addEventListener('DOMContentLoaded', () => {
  const header = $('[data-header]');
  const updateHeader = () => header?.classList.toggle('is-scrolled', scrollY > 24);
  updateHeader();
  addEventListener('scroll', updateHeader, { passive: true });

  const drawer = $('#MobileDrawer');
  const drawerToggles = $$('[data-drawer-toggle]');
  let drawerTrigger = null;
  const setDrawer = (open) => {
    if (!drawer) return;
    drawer.toggleAttribute('open', open);
    drawerToggles.forEach((button) => button.setAttribute('aria-expanded', String(open)));
    document.body.classList.toggle('no-scroll', open);
    if (open) {
      drawer.querySelector('button, a')?.focus();
    } else {
      drawerTrigger?.focus();
    }
  };

  drawerToggles.forEach((button) => {
    button.addEventListener('click', () => {
      const willOpen = !drawer?.hasAttribute('open');
      if (willOpen) drawerTrigger = button;
      setDrawer(willOpen);
    });
  });
  $$('a', drawer).forEach((link) => link.addEventListener('click', () => setDrawer(false)));
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && drawer?.hasAttribute('open')) setDrawer(false);
  });

  $$('[data-filter]').forEach((button) => button.addEventListener('click', () => {
    const gallery = button.closest('[data-gallery]');
    $$('[data-filter]', gallery).forEach((item) => item.classList.toggle('active', item === button));
    $$('[data-category]', gallery).forEach((item) => {
      item.hidden = button.dataset.filter !== 'all' && item.dataset.category !== button.dataset.filter;
    });
  }));

  $$('[data-lightbox]').forEach((button) => button.addEventListener('click', () => {
    const dialog = $('#Me5aLightbox');
    const sourceImage = $('img', button);
    if (dialog && sourceImage) {
      $('img', dialog).src = sourceImage.currentSrc || sourceImage.src;
      dialog.showModal();
    }
  }));
  $$('[data-close-lightbox]').forEach((button) => button.addEventListener('click', () => button.closest('dialog')?.close()));
});
